import React, { FC, Key } from 'react'
import cn from 'classnames'
import styles from './GroupTabs.module.css'
import { Icon, IconType } from '../../Icon'

type Props = {
  selected: Key
  className?: string
  tabClassName?: string
  tabs: GroupTab[]
  onTabChanged: (key: Key) => void
}

type GroupTab = {
  icon: IconType
  text?: string
  disabled?: boolean
}

export const GroupTabs: FC<Props> = ({
  className,
  tabClassName,
  selected,
  onTabChanged,
  tabs
}) => {
  return (
    <div className={cn([styles.root, className])}>
      {tabs.map((child, i) => (
        <div
          key={i}
          className={cn(
            styles.tab,
            {
              [styles.selected]: i === selected,
              [styles.disabled]: child.disabled
            },
            tabClassName
          )}
          onClick={() => onTabChanged(i)}
        >
          <Icon icon={child.icon} className={styles.tabIcon} />
          {child.text && <span className={styles.tabText}>{child.text}</span>}
        </div>
      ))}
    </div>
  )
}
